import { useEffect, useState } from 'react';
import { getKeyByValue } from 'utils/context/FilterContext/utils';
import DK from 'utils/dictionaries/filter_dictionary';
import { useDebouncedCallback } from 'utils/hooks';
import fetchSuggestions from 'utils/hooks/useSuggestions/fetchSuggestions';

import { IAutocompleteRequest } from '@project44-models/shipment-list';

const useSuggestions = (fieldType: string, fieldName: string = '') => {
  const [suggestions, setSuggestions] = useState<string[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [query, setQuery] = useState('');
  const setQueryDebounced = useDebouncedCallback(setQuery);

  useEffect(() => {
    const fieldKey = getKeyByValue(DK, fieldType);
    if (fieldKey === 'STOP_TYPE' || fieldKey == 'EVENT_STOP_TYPE') {
      setSuggestions(
        [
          // TODO Internationalize
          fieldKey === 'EVENT_STOP_TYPE' ? 'ORIGIN' : '',
          fieldKey === 'EVENT_STOP_TYPE' ? 'DESTINATION' : '',
          'PORT_OF_DISCHARGE',
          'PORT_OF_LOADING',
          'TRANSFER',
          'TRANSSHIPMENT_PORT',
          'OTHER',
          'UNKNOWN',
        ].filter(Boolean),
      );
    } else if (fieldType && fieldName) {
      const body = {
        fieldName,
        fieldType: fieldKey,
        limit: 100,
        query,
      } as IAutocompleteRequest;

      setIsError(false);
      setIsLoading(true);
      fetchSuggestions(body)
        .then((response) => {
          setSuggestions(response);
          setIsLoading(false);
        })
        .catch(() => {
          setSuggestions([]);
          setIsError(true);
          setIsLoading(false);
        });
    }
  }, [fieldName, fieldType, query]);

  return {
    isError,
    isLoading,
    query,
    setQuery: setQueryDebounced,
    suggestions,
  };
};

export default useSuggestions;
